import React, { Component } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { selectImage } from '../actions/index';
import { bindActionCreators } from 'redux';

class Fullscreen extends Component {
  constructor(props) {
    super(props);
    this.state = { imageLoaded: false };
  }
  onImageLoad() {
    setTimeout(() => {
      this.setState({ imageLoaded: true });
    }, 40);
  }
  onCloseHandler() {
    this.setState({ imageLoaded: false });
    this.props.selectImage(null);
  }
  onPrevClickHandler(imageUrls) {
    if (this.props.activeImageIndex > 0) {
      this.setState({ imageLoaded: false });
      this.props.selectImage(this.props.activeImageIndex - 1);
    }
  }
  onNextClickHandler(imageUrls) {
    if (this.props.activeImageIndex < imageUrls.length - 1) {
      this.setState({ imageLoaded: false });
      this.props.selectImage(this.props.activeImageIndex + 1);
    }
  }
  render() {
    const imageUrls = [];
    this.props.panels.map(panel => {
      panel.panelContent.map(panelContent => {
        if (panelContent.type === 'image') {
          imageUrls.push(panelContent.url);
        }
      });
    });
    if (this.props.activeImageIndex == null) {
      return <div />;
    }
    return (
      <div className="pos-f t-0 w-100p h-100p bgc-black ta-c">
        <img
          className={classnames(
            'fullscreen-image w-a h-100p',
            { show: this.state.imageLoaded },
            { hide: !this.state.imageLoaded }
          )}
          src={imageUrls[this.props.activeImageIndex]}
          onLoad={this.onImageLoad.bind(this)}
        />
        <img
          className="close-icon pos-a cur-p"
          onClick={this.onCloseHandler.bind(this)}
          src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOS4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9Ii0xMTc3LjkgNjU3LjMgNTEuOCA1MS44IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IC0xMTc3LjkgNjU3LjMgNTEuOCA1MS44OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojRkZGRkZGO30NCjwvc3R5bGU+DQo8Zz4NCgk8cG9seWdvbiBjbGFzcz0ic3QwIiBwb2ludHM9Ii0xMTc2LjUsNzA5LjEgLTExNTIsNjg0LjYgLTExMjcuNSw3MDkuMSAtMTEyNi4xLDcwNy43IC0xMTUwLjYsNjgzLjIgLTExMjYuMSw2NTguNyAtMTEyNy41LDY1Ny4zIA0KCQktMTE1Miw2ODEuOCAtMTE3Ni41LDY1Ny4zIC0xMTc3LjksNjU4LjcgLTExNTMuNCw2ODMuMiAtMTE3Ny45LDcwNy43IAkiLz4NCjwvZz4NCjwvc3ZnPg0K"
        />
        <img
          className="prev-icon pos-a t-50p trf-ty-minus50p cur-p"
          onClick={this.onPrevClickHandler.bind(this, imageUrls)}
          src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOS4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9Ii02MjggMzQwLjMgMjEuMSA0MC43IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IC02MjggMzQwLjMgMjEuMSA0MC43OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojRkZGRkZGO30NCjwvc3R5bGU+DQo8dGl0bGU+Q2hldnJvbiBTcSAxPC90aXRsZT4NCjxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPg0KPGcgdHJhbnNmb3JtPSJtYXRyaXgoLTEsIDAsIDAsIC0xLCAxMDAuMTczMjI1LCAxMDApIj4NCgk8Zz4NCgkJPHBvbHlnb24gY2xhc3M9InN0MCIgcG9pbnRzPSI3MDcuMSwtMjQxIDcwNy45LC0yNDAuMiA3MjguMiwtMjYwLjYgNzA3LjksLTI4MSA3MDcuMSwtMjgwLjIgNzI2LjgsLTI2MC42IAkJIi8+DQoJPC9nPg0KPC9nPg0KPC9zdmc+DQo="
        />
        <img
          className="next-icon pos-a t-50p trf-ty-minus50p cur-p"
          onClick={this.onNextClickHandler.bind(this, imageUrls)}
          src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOS4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9Ii0xMjU2IDY4MC41IDIxLjEgNDAuOCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAtMTI1NiA2ODAuNSAyMS4xIDQwLjg7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOiNGRkZGRkY7fQ0KPC9zdHlsZT4NCjx0aXRsZT5DaGV2cm9uIFNxIDE8L3RpdGxlPg0KPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+DQo8ZyB0cmFuc2Zvcm09Im1hdHJpeCgtMSwgMCwgMCwgLTEsIDEwMC4xNzMyMjUsIDEwMCkiPg0KCTxnPg0KCQk8cG9seWdvbiBjbGFzcz0ic3QwIiBwb2ludHM9IjEzMzYuNSwtNjAwLjkgMTM1Ni4yLC02MjAuNSAxMzU1LjQsLTYyMS4zIDEzMzUuMSwtNjAwLjkgMTM1NS40LC01ODAuNSAxMzU2LjIsLTU4MS4zIAkJIi8+DQoJPC9nPg0KPC9nPg0KPC9zdmc+DQo="
        />
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    panels: state.panels,
    activeImageIndex: state.activeImageIndex
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ selectImage: selectImage }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(Fullscreen);



// WEBPACK FOOTER //
// ./src/containers/fullscreen.js